import { useCallback, useEffect, useState } from "react";

import { ListarParcelasAbertasDadosFinanceirosController } from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";
import {
    IDadosFinanceirosForm,
    IDadosFinanceirosReceber,
} from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";

import { formatMoneyReais } from "../../../../Tools/FormatTools";
import moment from "moment";
import "moment/locale/pt-br";

import SpinnerUAU from "../../../Loding/SpinnerUAU";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import Table from "../../../Table";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useForm } from "react-hook-form";
import { faDollarSign } from "@fortawesome/free-solid-svg-icons";
import { useUserInfor } from "../../../../Context/User";

interface IDadosFinanceirosAbertasProps {
    ID_CHAVE_ERP: string;
}

export default function DadosFinanceirosAbertas(
    props: IDadosFinanceirosAbertasProps
) {
    const { register, handleSubmit, formState } =
        useForm<IDadosFinanceirosForm>();
    const { OrgInfor } = useUserInfor();
    const [loading, setLoading] = useState(false);
    const [lstContasReceber, setLstContasReceber] = useState<
        Array<IDadosFinanceirosReceber>
    >([]);
    const [lstSelecionados, setlstSelecionados] = useState<
        Array<IDadosFinanceirosReceber>
    >([]);

    const [indicadores, setIndicadores] = useState({
        REAJ: 0,
        ORIGINAL: 0,
        JUROS: 0,
        MULTA: 0,
        CORRECAO: 0,
        QTD_PARCELAS: 0,
    });
    const [reqData, setReqData] = useState({
        DT_CALCULO: new Date().toISOString().substring(0, 10),
        antecipacao: false,
    });

    const updateDadosFinanceiros = useCallback(() => {
        setLoading(true);
        ListarParcelasAbertasDadosFinanceirosController(
            {
                ID_CHAVE_ERP: props.ID_CHAVE_ERP,
                DT_CALCULO: reqData.DT_CALCULO,
            },
            reqData.antecipacao
        )
            .then((res) => {
                setLstContasReceber(res);
                console.log(res);

                const RECEBER = {
                    ...res.reduce(
                        (indicadores, parcela) => ({
                            REAJ: indicadores.REAJ + parcela.ValorReaj,
                            ORIGINAL: indicadores.ORIGINAL + parcela.Valor_Prc,
                            JUROS: indicadores.JUROS + parcela.vlrJurosAtraso,
                            MULTA: indicadores.MULTA + parcela.ValorMulta,
                            CORRECAO:
                                indicadores.CORRECAO + parcela.vlrCorrecaoAtra,
                        }),
                        {
                            REAJ: 0,
                            ORIGINAL: 0,
                            JUROS: 0,
                            MULTA: 0,
                            CORRECAO: 0,
                        }
                    ),
                    QTD_PARCELAS: res.length,
                };
                setIndicadores({
                    ...RECEBER,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [props.ID_CHAVE_ERP, reqData]);

    useEffect(() => {
        updateDadosFinanceiros();
    }, [updateDadosFinanceiros]);

    function handleDadosFinanceirosFormSubmit(formData: IDadosFinanceirosForm) {
        setReqData({ ...formData });
    }

    const selectRowProp: SelectRowProps<IDadosFinanceirosReceber> = {
        mode: "checkbox",
        onSelect: (row, isSelect) => {
            row.FL_MARC = isSelect;
            const lstParcelasMarcadas =
                lstContasReceber?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        onSelectAll: (isSelect, rows: Array<IDadosFinanceirosReceber>) => {
            rows.forEach((row) => {
                row.FL_MARC = isSelect;
            });
            const lstParcelasMarcadas =
                lstContasReceber?.filter((p) => p.FL_MARC) ?? [];
            setlstSelecionados(lstParcelasMarcadas);
        },
        selected: lstSelecionados.map((selecionados) => {
            return selecionados.ID_CHAVE_PARCELA;
        }),
    };

    let total = {
        parcelaOriginal: 0,
        juros: 0,
        multa: 0,
        total: 0,
        reajuste: 0,
    };
    lstSelecionados.forEach((selecionado) => {
        total.parcelaOriginal += selecionado.Valor_Prc;
        total.juros += selecionado.vlrJurosAtraso;
        total.multa += selecionado.ValorMulta;
        total.reajuste += selecionado.ValorReaj;
        total.total +=
            selecionado.vlrJurosAtraso +
            selecionado.ValorMulta +
            selecionado.Valor_Prc;
    });

    return (
        <div className="p-6">
            {OrgInfor.COD_ERP_INTEGRACAO === "UAU" ||
            OrgInfor.COD_ERP_INTEGRACAO === "INFORMAKON" ? (
                <form
                    className="row align-items-center mb-2"
                    onSubmit={handleSubmit(handleDadosFinanceirosFormSubmit)}
                >
                    <div className="col-12 col-md-4">
                        <label className="text-muted mb-0">
                            {" "}
                            Data de Cálculo
                        </label>
                        <input
                            type="date"
                            name="DT_CALCULO"
                            placeholder={"Digite o email"}
                            className={`form-control px-0 p-2 placeholder-dark-75 ${
                                formState.errors.DT_CALCULO && "is-invalid"
                            }`}
                            ref={register({
                                required: "Data de Cálculo obrigatória",
                            })}
                            defaultValue={new Date()
                                .toISOString()
                                .substring(0, 10)}
                        />
                    </div>
                    <div className="col-12 col-md-4">
                        <div className="d-flex align-items-center justify-content-center">
                            <span>Antecipacao</span>
                        </div>
                        <span
                            className="switch switch-outline switch-sm switch-icon switch-success d-flex justify-content-center align-items-center mt-1"
                            data-toggle="tooltip"
                        >
                            <label>
                                <input
                                    name="antecipacao"
                                    type="checkbox"
                                    ref={register()}
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                    <div className="col-12 col-md-4">
                        <button
                            type="submit"
                            className="btn btn-block btn-outline-dark mt-2"
                        >
                            <FontAwesomeIcon
                                icon={faDollarSign}
                                className="mr-2"
                            />
                            Carregar Dados
                        </button>
                    </div>
                </form>
            ) : (
                <></>
            )}

            {!loading ? (
                <div className="p-2">
                    <div className="d-flex flex-wrap justify-content-between mb-2 pl-5 pt-5">
                        <h3>Contas a Receber</h3>
                        <div className="text-right pr-5">
                            {indicadores.QTD_PARCELAS} Parcelas
                        </div>
                    </div>

                    {lstContasReceber && (
                        <>
                            <Table
                                columns={columns}
                                data={lstContasReceber}
                                keyField="ID_CHAVE_PARCELA"
                                tableView={{ columns: columnsTableView }}
                                bordered={false}
                                wrapperClasses="y-scroll maxHeight-300 mb-2"
                                noDataIndication={
                                    <div className="text-center text-muted">
                                        Nenhuma parcela a receber
                                    </div>
                                }
                                selectRow={selectRowProp}
                            />
                            <div className="card card-custom w-auto my-2 p-2">
                                <div className="d-flex flex-wrap justify-content-around mr-1">
                                    {!!indicadores.REAJ && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Valor Reaj.
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.REAJ
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.ORIGINAL && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Valor Original
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.ORIGINAL
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.MULTA && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Multa
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.MULTA
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.JUROS && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Juros
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.JUROS
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.CORRECAO && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Correção e Acréscimos
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.CORRECAO
                                                )}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex flex-column justify-content-between align-items-center border border-dark">
                                    <div
                                        className="font-weight-bold"
                                        style={{
                                            fontSize: 17,
                                            textAlign: "center",
                                        }}
                                    >
                                        Parcelas Selecionadas
                                    </div>
                                    <div className="d-flex justify-content-between g-2">
                                        {" "}
                                        <span
                                            className=" ml-2"
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Total:{" "}
                                            {formatMoneyReais(total.total)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Reajuste:{" "}
                                            {formatMoneyReais(total.reajuste)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Multa Total:{" "}
                                            {formatMoneyReais(total.multa)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Juros Total:{" "}
                                            {formatMoneyReais(total.juros)}
                                        </span>
                                        <span
                                            className=" mr-2"
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Original Total:{" "}
                                            {formatMoneyReais(
                                                total.parcelaOriginal
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <SpinnerUAU />
            )}
        </div>
    );
}

//Tabela
const columns: Array<ColumnDescription> = [
    {
        dataField: "ID_CHAVE_PARCELA",
        text: "",
        headerClasses: "d-none",
        formatter: (c, row) => <RowReceber {...row} />,
    },
];
const columnsTableView: Array<ColumnDescription> = [
    {
        dataField: "Tipo_Prc",
        text: "Parcela",
        classes: "p-3 ws-nowrap",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {c}{" "}
                    {row.Descricao_par && <span> - {row.Descricao_par} </span>}{" "}
                    - {row.NumParc_Prc}
                </span>
            );
        },
        headerAlign: "center",
    },
    {
        dataField: "Data_Prc",
        text: "Data de Vencimento",
        formatter: (c) => {
            const data = new Date(c);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {new Date(c).toLocaleDateString()}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "ValorReaj",
        text: "Valor Reajus.",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "Valor_Prc",
        text: "Valor Principal",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "ValorMulta",
        text: "Multa",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "vlrJurosAtraso",
        text: "Juros",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "vlrJurosParcela",
        text: "Juros Parcela",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "vlrCorrecaoAtra",
        text: "Correção e atraso",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
    {
        dataField: "vlrCorrecao",
        text: "Correção",
        formatter: (c, row) => {
            const data = new Date(row.Data_Prc);
            return (
                <span
                    className={data.getTime() < Date.now() ? "text-danger" : ""}
                >
                    {formatMoneyReais(c)}
                </span>
            );
        },
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
    },
];
function RowReceber(parcela: IDadosFinanceirosReceber) {
    const parcelaVencida = new Date(parcela.Data_Prc).getTime() < Date.now();

    return (
        <div
            className={`card card-custom w-auto ml-auto wave wave-animate-slow wave-${
                parcelaVencida ? "danger" : "warning"
            } border-bottom border-1 border-dark`}
        >
            <div className="card-body p-3">
                <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                    <h3 className="font-weight-bolder font-size-normal">
                        <span className="text-dark-75">
                            {parcela.Tipo_Prc} - {parcela.NumParc_Prc}
                        </span>
                    </h3>
                    <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                        <div className="d-flex flex-wrap flex-column">
                            <span className="d-block font-weight-bold">
                                Data Vencimento
                            </span>
                            <span
                                className={`label label-${
                                    parcelaVencida ? "danger" : "light-primary"
                                } label-inline mr-2 my-1`}
                            >
                                {moment(parcela.Data_Prc).format("ll")}
                            </span>
                        </div>
                    </div>
                </div>

                <div className="d-flex flex-wrap justify-content-around mr-1">
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Reajus.
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.ValorReaj)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Principal
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.Valor_Prc)}
                        </span>
                    </div>

                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Multa
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.ValorMulta)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Juros
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.vlrJurosAtraso)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Juros Parcela
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.vlrJurosParcela)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Correção e atraso
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.vlrCorrecaoAtra)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Correção
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.vlrCorrecao)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
